<script>
import Vue from 'vue'
import Vuelidate from 'vuelidate'
import { required, minLength, maxLength } from 'vuelidate/lib/validators'
import { emailRule, loginAndPasswordChangejleagueIdRule } from '../validation/rules'

Vue.use(Vuelidate)

export default {
    data() {
        return {
            jleague_id: '',
            inputEmail: ''
        }
    },
    validations: {
        jleague_id: {
            required,
            minLength: minLength(6),
            maxLength: maxLength(128),
            loginAndPasswordChangejleagueIdRule
        },
        inputEmail: {
            required,
            emailRule
        }
    },
    computed: {
        email: function(){
            return this.inputEmail.toLowerCase();
        },
        isDisabled: function(){
            return this.$v.$invalid;
        }
    },
    methods: {}
}
</script>
